import React, { Component } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import * as actionTypes from "../../store/actions";
import axios from "axios";
import { connect } from "react-redux";
import "./Home.scss";
import CryptoJS from "crypto-js";
import qs from "query-string";
import { saveSettings } from "../../utils/checkSettings";

// This component has been repurposed from Trend's version. Some code of is commented out
// If you need the full project, pull livetest-emco in the dw-revamp-emco project off Heroku
export class Home extends Component {
	static propTypes = {
		prop: PropTypes
	};

	state = {
		username: "",
		loggedin: false,
		response: [],
		loadingAnimation: null
	};

	componentDidMount = async () => {
		const parsed = qs.parse(this.props.location.search);
		const loginUrl = this.props.APIUrl + "/login";

		this.setState({ response: ["loading", "Loading..."] });
		try {
			if (parsed.h && parsed.i) {
				// Instead logging the user's token in the main route, a secondary route will
				// Check the token to ensure the user hasn't had that token before
				// Without this, anyone could take the redirect route and login as that user
				let checkURL = this.props.APIUrl + "/login/check-user";
				let login = await axios.post(checkURL, { parsed });

				if(login.data.token === parsed.i) {
					const usernameParsed = CryptoJS.AES.decrypt(parsed.h.toString(), process.env.REACT_APP_PASSWORD_KEY).toString(CryptoJS.enc.Utf8);
					
					localStorage.setItem("token", parsed.i);
					localStorage.setItem("trendId", usernameParsed);
					Object.keys(login.data.permissions).forEach((permission) => {
						localStorage.setItem(permission, permission);
					});

					let ajaxURL = this.props.APIUrl + "/settings/get-user-settings";
					let settings = await axios.post(ajaxURL, { trendId: usernameParsed });
					saveSettings(settings.data);

					await this.props.onLoggedIn();

					this.setState({ loggedin: true });
				} else {
					// If the token has already been used by the user, redirect to login
					return window.location.href = loginUrl;
				}
			} else {
				// If parsed h & i aren't assigned or if there's no query string, redirect to login
				return window.location.href = loginUrl;
			}
		} catch (e) {
			this.setState({ response: ["error", e.message] });
		}
		this.props.history.push('/');
		this.setState({ redirect: <Redirect to="/" /> });
	}
	
	render() {
		// Mount an empty component to run ComponentDidMount
		// Returning/running a function could return an error while its finishing
		// Or make multiple function calls which results in multiple server calls
		return (null);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = dispatch => {
	return {
		onLoggedIn: (trendId, trendPassword, userToken) => dispatch({ type: actionTypes.SAVE_USER })
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Home);